import { ExpansionPanel, ExpansionPanelContent } from "@progress/kendo-react-layout";

interface CommonExpansionPanelProps {
  id: string;
  title: React.ReactNode;
  expanded: boolean;
  className?:string
  onAction: () => void;
  children?: React.ReactNode;
}

const CommonExpansionPanel: React.FC<CommonExpansionPanelProps> = ({
  id,
  title,
  expanded,
  className,
  onAction,
  children,
}) => {
  return (
    <ExpansionPanel id={id} title={title} expanded={expanded} onAction={onAction} className={className}>
      {expanded && <ExpansionPanelContent>{children}</ExpansionPanelContent>}
    </ExpansionPanel>
  );
};

export default CommonExpansionPanel;
